import { Dialog as DialogPrimitive } from "radix-ui";

import { cn } from "../../lib/cn";

interface DialogTitleProps {
  children: React.ReactNode;
  className?: string;
}

function DialogTitle({ children, className }: DialogTitleProps) {
  return (
    <DialogPrimitive.Title className={cn("text-lg font-semibold", className)}>
      {children}
    </DialogPrimitive.Title>
  );
}

export { DialogTitle };
